// extracted by extract-css-chunks-webpack-plugin
module.exports = {"group_tools":"GroupTools__group_tools--2_Tq1","plusicon":"GroupTools__plusicon--3On8s"};